(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const scene = document.currentScript?.closest('.shopify-section')?.querySelector('[data-story-scene]');
    if (!scene) return;

    const updateStoryParallax = () => {
      const rect = scene.getBoundingClientRect();
      const distance = window.innerHeight * 0.5 - (rect.top + rect.height * 0.5);
      const clamped = Math.max(-48, Math.min(48, distance * 0.18));
      scene.style.setProperty('--story-parallax', `${clamped.toFixed(2)}px`);
    };

    updateStoryParallax();
    window.addEventListener('scroll', updateStoryParallax, { passive: true });
    window.addEventListener('resize', updateStoryParallax);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
